import { Injectable, inject } from '@angular/core';

import { FormSchema } from '@core/form-generator-engine/abstractions/form-schema';
import { PageSchema } from '@core/form-generator-engine/abstractions/page-schema';
import { PanelSchema } from '@core/form-generator-engine/abstractions/panel-schema';
import { QuestionControlSchema } from '@core/form-generator-engine/abstractions/question-control-schema';
import { QuestionSchema } from '@core/form-generator-engine/abstractions/question-schema';
import { Controls } from '@core/form-generator-engine/helpers';
import { TranslateService } from '@ngx-translate/core';
import { EvaluationResponse } from 'src/app/web-api-client';
import { QuestionType } from '../abstractions/question-type';

@Injectable()
export class SchemaFactoryService {
  private readonly translate = inject(TranslateService);

  getTaxResultControl(
    taxPolicyId: number,
    taxRuleId: number,
    description: string,
    rate: string
  ): QuestionControlSchema[] {
    const isDisabled = true;
    return [
      this.getQuestionControl(
        '',
        QuestionType.Integer,
        this.translate.instant('upsertSecurity.taxResult'),
        {
          taxPolicyId: taxPolicyId ?? 0,
          ruleId: taxRuleId ?? 0,
        },
        isDisabled,
        rate
      ),
      this.getQuestionControl(
        '',
        QuestionType.String,
        this.translate.instant('upsertSecurity.explanation'),
        {
          taxPolicyId: taxPolicyId ?? 0,
          ruleId: taxRuleId ?? 0,
        },
        isDisabled,
        description
      ),
    ];
  }

  getQuestionControl(
    questionText: string,
    type: number,
    label: string,
    metadata: JSONValue,
    disabled: boolean,
    value?: string
  ): QuestionControlSchema {
    return {
      name: crypto.randomUUID(),
      questionText,
      componentType: this.getComponentType(type),
      label,
      metadata,
      value,
      disabled,
    } as unknown as QuestionControlSchema;
  }

  getQuestion(evaluationResponse: EvaluationResponse): QuestionSchema {
    return {
      questionId: evaluationResponse.question!.questionId ?? 0,
      name: evaluationResponse.question!.name ?? '',
      questionText: evaluationResponse.question
        ? evaluationResponse.question.question
        : '',
      componentType: Controls.Question,
      elements: [],
      metadata: {
        taxPolicyId: evaluationResponse.taxPolicyId ?? 0,
        ruleId: evaluationResponse.callTaxRuleId ?? 0,
      },
    } as unknown as QuestionSchema;
  }

  getPanel(evaluationResponse: EvaluationResponse, index: number): PanelSchema {
    return {
      name: `panel-${index + 1}`,
      elements: [],
      componentType: Controls.Panel,
      title: '',
      metadata: {
        taxPolicyId: evaluationResponse.taxPolicyId ?? 0,
        ruleId: evaluationResponse.callTaxRuleId ?? 0,
      },
    } as unknown as PanelSchema;
  }

  getPage(evaluationResponse: EvaluationResponse, index: number): PageSchema {
    return {
      name: `page-${index + 1}`,
      componentType: Controls.Page,
      metadata: {
        taxPolicyId: evaluationResponse.taxPolicyId ?? 0,
        ruleId: evaluationResponse.callTaxRuleId ?? 0,
      },
      title: '',
      isVisible: true,
      elements: [],
    } as unknown as PageSchema;
  }

  getFormSchema(): FormSchema {
    return {
      elements: [],
      title: this.translate.instant('upsertSecurity.additionalInquiries'),
    } as unknown as FormSchema;
  }

  getComponentType(type: QuestionType): Controls {
    if (type === QuestionType.Boolean) {
      return Controls.Boolean;
    } else if (type === QuestionType.Integer) {
      return Controls.Percent;
    }
    return Controls.Textfield;
  }
}
